import React from "react"
import { ConfiguracaoFormasDePagamentoContextProvider } from "./context/ConfiguracaoFormasDePagamentoContextProvider"
import { ConfiguracaoFormasDePagamento } from "./ConfiguracaoFormasDePagamento"

export function Index() {
    return (
        <ConfiguracaoFormasDePagamentoContextProvider>
            <ConfiguracaoFormasDePagamento />
        </ConfiguracaoFormasDePagamentoContextProvider>
    )
}
